import { render, staticRenderFns } from "./College.vue?vue&type=template&id=7426133f"
import script from "./College.vue?vue&type=script&lang=js"
export * from "./College.vue?vue&type=script&lang=js"
import style0 from "./College.vue?vue&type=style&index=0&id=7426133f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports